module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/reservation@2x-db31b6dbc46ffdd7f72600aba53e847e.webp";